module.exports = __webpack_public_path__ + "img/card_ip_stipulation85.b0fb1b20.svg";